import { render, staticRenderFns } from "./ConflictList.vue?vue&type=template&id=0898efcc&"
import script from "./ConflictList.vue?vue&type=script&lang=js&"
export * from "./ConflictList.vue?vue&type=script&lang=js&"
import style0 from "./ConflictList.vue?vue&type=style&index=0&id=0898efcc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports